module.exports = __webpack_public_path__ + "static/logo-6a9ad7dab59ab221e0c140aafc884faf.svg";